export const PagesActions = {
    FETCH_PAGES: 'FETCH_PAGES',

    CREATE_PAGE: 'CREATE_PAGE',
    IS_CREATING: 'IS_CREATING',
    CREATE_PAGE_SUCCESS: 'CREATE_PAGE_SUCCESS',
    CREATE_PAGE_ERROR: 'CREATE_PAGE_ERROR',
    CLEAR_PAGE_CREATION_STATE: 'CLEAR_PAGE_CREATION_STATE',

    DELETE_PAGE: 'DELETE_PAGE',
    IS_DELETING: 'IS_DELETING',
    DELETE_PAGE_SUCCESS: 'DELETE_PAGE_SUCCESS',
    DELETE_PAGE_ERROR: 'DELETE_PAGE_ERROR',
    CLEAR_PAGE_DELETION_STATE: 'CLEAR_PAGE_DELETION_STATE',

    UPDATE_PAGES: 'UPDATE_PAGES',
    IS_UPDATING: 'IS_UPDATING',
    UPDATE_PAGES_SUCCESS: 'UPDATE_PAGES_SUCCESS',
    UPDATE_PAGES_ERROR: 'UPDATE_PAGES_ERROR',
    CLEAR_PAGE_UPDATE_STATE: 'CLEAR_PAGE_UPDATE_STATE',

    PUBLISH_SITE_NAV: 'PUBLISH_SITE_NAV',
    PUBLISH_SITE_NAV_SUCCESS: 'PUBLISH_SITE_NAV_SUCCESS',
    PUBLISH_SITE_NAV_ERROR: 'PUBLISH_SITE_NAV_ERROR',
    CLEAR_PUBLISH_SITE_NAV: 'CLEAR_PUBLISH_SITE_NAV',

    FETCH_INDEX: 'FETCH_INDEX',
    SET_INDEX_PAGE: 'SET_INDEX_PAGE',
    PUBLISH_INDEX_PAGE: 'PUBLISH_INDEX_PAGE',
    SET_INDEX_SUCCESS: 'SET_INDEX_SUCCESS',
    SET_INDEX_ERROR: 'SET_INDEX_ERROR'
};

/*~~~~ FETCH_PAGES ~~~~*/
export const fetchPages = payload => ({
    type: PagesActions.FETCH_PAGES,
    payload
});

/*~~~~ CREATE_PAGE ~~~~*/
export const createPage = payload => ({
    type: PagesActions.CREATE_PAGE,
    payload
});
export const isCreating = () => ({
    type: PagesActions.IS_CREATING
});
export const createPageSuccess = () => ({
    type: PagesActions.CREATE_PAGE_SUCCESS
});
export const createPageError = payload => {
    return {
        type: PagesActions.CREATE_PAGE_ERROR,
        payload
    };
};
export const clearPageCreationState = payload => {
    return {
        type: PagesActions.CLEAR_PAGE_CREATION_STATE
    };
};

/*~~~~ DELETE_PAGE ~~~~*/
export const deletePage = payload => ({
    type: PagesActions.DELETE_PAGE,
    payload
});
export const isDeleting = () => ({
    type: PagesActions.IS_DELETING
});
export const deletePageSuccess = () => ({
    type: PagesActions.DELETE_PAGE_SUCCESS
});
export const deletePageError = payload => {
    return {
        type: PagesActions.DELETE_PAGE_ERROR,
        payload
    };
};
export const clearPageDeletionState = payload => {
    return {
        type: PagesActions.CLEAR_PAGE_DELETION_STATE
    };
};

/*~~~~ UPDATE_PAGES ~~~~*/
export const updatePages = payload => ({
    type: PagesActions.UPDATE_PAGES,
    payload
});
export const isUpdating = () => ({
    type: PagesActions.IS_UPDATING
});
export const updatePagesSuccess = () => ({
    type: PagesActions.UPDATE_PAGES_SUCCESS
});
export const updatePagesError = payload => ({
    type: PagesActions.UPDATE_PAGES_ERROR,
    payload
});
export const clearPageUpdateState = payload => ({
    type: PagesActions.CLEAR_PAGE_UPDATE_STATE
});

/*~~~~ PUBLISH_SITE_NAV ~~~~*/
export const publishSiteNavigation = payload => ({
    type: PagesActions.PUBLISH_SITE_NAV,
    payload
});
export const publishSiteNavigationSuccess = payload => ({
    type: PagesActions.PUBLISH_SITE_NAV_SUCCESS,
    payload
});
export const publishSiteNavigationError = payload => ({
    type: PagesActions.PUBLISH_SITE_NAV_ERROR,
    payload
});
export const clearPublishSiteNavigation = payload => ({
    type: PagesActions.CLEAR_PUBLISH_SITE_NAV,
    payload
});

/*~~~~ INDEX_PAGE ~~~~*/
export const fetchIndex = payload => ({
    type: PagesActions.FETCH_INDEX,
    payload
});
export const setIndexPage = payload => ({
    type: PagesActions.SET_INDEX_PAGE,
    payload
});
export const publishIndexPage = payload => ({
    type: PagesActions.PUBLISH_INDEX_PAGE,
    payload
});
export const setIndexSuccess = () => ({
    type: PagesActions.SET_INDEX_SUCCESS
});
export const setIndexError = payload => ({
    type: PagesActions.SET_INDEX_ERROR,
    payload
});
